<!-- @format -->

<template>
	<!-- <van-field>
		<template #input> -->
	<div>
		<van-tag v-for="tag in value" :key="tag" class="mx-1" closable @close="handleClose(tag)">
			{{ tag }}
		</van-tag>
		<van-field
			v-if="inputVisible"
			ref="InputRef"
			v-model="inputValue"
			@keyup.enter="handleInputConfirm"
			@blur="handleInputConfirm"
		/>
		<van-button v-else @click="showInput"> + 新增 </van-button>
	</div>
	<!-- </template>
	</van-field> -->
</template>

<script setup lang="ts">
	import { ElInput } from 'element-plus';

	interface Props {
		modelValue: string;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue ? props.modelValue?.split(',') : [];
		},
		set(val) {
			emit('update:modelValue', val.join(','));
		},
	});

	const inputValue = ref('');
	const inputVisible = ref(false);
	const InputRef = ref<InstanceType<typeof ElInput>>();

	const handleClose = (tag: string) => {
		const arr = value.value.filter((i) => i !== tag);
		value.value = arr;
	};

	const showInput = () => {
		inputVisible.value = true;
		nextTick(() => {
			InputRef.value!.input!.focus();
		});
	};

	const handleInputConfirm = () => {
		if (inputValue.value) {
			const arr = value.value.concat(inputValue.value);
			value.value = arr;
		}
		inputVisible.value = false;
		inputValue.value = '';
	};
</script>

<style scoped lang="scss">
	.mx-1 {
		margin: 0 2px;
	}
</style>
